module.exports = __webpack_public_path__ + "img/rectangle.af39224a.svg";